import React from 'react';
import './diagrams.css';

/* Case 03 hero — the taste-automation layer. Three domains feed ONE
   human-gated pipeline. The accent is reserved for the human approval gate:
   the one thing the case is really about ("what I refused to automate"). */

const PILLARS = [
  { h: 'Discovery', meta: 'findability', items: ['Metadata & tags', 'Editorial collections'] },
  { h: 'Content quality', meta: 'engagement', items: ['Visuals & backdrops', 'Sendable, high-quality moments'] },
  { h: 'Artist presence', meta: 'freshness', items: ['Profiles & imagery', 'Kept complete & current'] },
];

const STAGES = [
  { n: '01', t: 'Task enters', d: 'a Feel, a collection, a backdrop, a profile' },
  { n: '02', t: 'AI first pass', d: 'an agent applies the encoded taste', loop: 'self-review — re-checks against the rulebook' },
  { n: '03', t: 'Human approval', d: 'I approve, correct, or reject — taste held here', accent: true },
  { n: '04', t: 'Applied live', d: 'ships to the app instantly' },
];

export default function AIPipeline() {
  return (
    <figure className="ppd">
      <div className="ppd__head">
        <h3 className="ppd__title">One rulebook. A fleet of agents. A human on every call.</h3>
        <span className="ppd__tag">Taste pipeline</span>
      </div>

      {/* three domains the taste layer runs across */}
      <div className="ppd__clusters">
        {PILLARS.map((p) => (
          <div key={p.h} className="ppd__cluster">
            <h4 className="ppd__cluster-h">{p.h} <span>{p.meta}</span></h4>
            <ul>{p.items.map((it) => <li key={it}>{it}</li>)}</ul>
          </div>
        ))}
      </div>

      <div className="ppd__cross"><span className="ppd__cross-line">one human-gated pipeline runs all of it</span></div>

      {/* the shared mechanism */}
      <div className="ppd__flow">
        {STAGES.map((s, i) => (
          <React.Fragment key={s.n}>
            <div className={`ppd__node${s.accent ? ' ppd__node--accent' : ''}`}>
              <span className="ppd__node-n">{s.n}</span>
              <span className="ppd__node-t">{s.t}</span>
              <span className="ppd__node-d">{s.d}</span>
              {s.loop && <span className="ppd__loop">{s.loop}</span>}
            </div>
            {i < STAGES.length - 1 && (
              <span className={`ppd__arrow${STAGES[i + 1].accent ? ' ppd__arrow--accent' : ''}`} aria-hidden="true" />
            )}
          </React.Fragment>
        ))}
      </div>

      <figcaption className="ppd__caption">
        The model does the first pass across all three areas and self-reviews against the written
        rules. The <b>approval gate is the line I won't automate</b>: nothing ships to a fan
        unreviewed. AI scales the labor; the human keeps the taste.
      </figcaption>
    </figure>
  );
}
